import React from 'react'
import { connect } from 'react-redux'
import { Item } from './Layout'
import Timeago from 'components/Utils/Timeago'

import { selectors as UsersSelectors } from 'data/users'
import { formatUsernames } from './utils'

const mapActionsToText = {
  create: ({ activity }) => <span> created it {'✨ '}</span>,
  update: ({ activity }) => (
    <span>
      {' '}
      updated {activity.get('metadata').get('field')} from "
      {activity.get('metadata').get('from')}" to "
      {activity.get('metadata').get('to')}" {'ℹ️ '}️{' '}
    </span>
  ),
  content: ({ activity, allUsers }) => (
    <span>
      {' '}
      wrote in it {'📝 '}{' '}
      {activity.get('metadata').get('mentionedIds') &&
        activity.get('metadata').get('mentionedIds').size > 0 && (
          <span>
            and mentioned{' '}
            {formatUsernames(
              allUsers,
              activity.get('metadata').get('mentionedIds')
            )}
          </span>
        )}
    </span>
  ),
  newThread: ({ activity }) => <span> commented {'💬 '}</span>,
  newComment: ({ activity }) => <span> replied to a comment {'💬 '}</span>,
}

const ActivityItem = ({ activity, allUsers }) => {
  const mapActionToText = mapActionsToText[activity.get('type')]
  if (!mapActionToText) {
    return false
  }
  return (
    <Item>
      {formatUsernames(allUsers, activity.get('userIds'))}{' '}
      {mapActionToText({
        activity,
        allUsers,
      })}{' '}
      <span className="shade-30">
        - <Timeago date={activity.get('createdAt')} />
      </span>
    </Item>
  )
}

const enhance = connect(state => ({
  allUsers: UsersSelectors.getAllUsers(state),
}))

export default enhance(ActivityItem)
